const language = Shopify.locale;

if (language === "de") {
  const destatter = window.location.href.includes("/bestatter");
  const nichtbestatter = window.location.href.includes("/nichtbestatter");
  const registerBestatter = window.location.href.includes("/register-bestatter");
  const registerGewerbe = window.location.href.includes("/register-gewerbe");

  const interval = setInterval(() => {
    const privacy = document.querySelector('.bss-b2b-rf-privacy-policy label[for="privacy-policy"] p');

    if (privacy) {
      clearInterval(interval);

      if (destatter || registerBestatter) {
        privacy.textContent = "Ich bestätige hiermit, dass ich im Bestattungsgewerbe tätig bin. Mir ist bekannt, dass Falschangaben rechtliche Konsequenzen haben können.";
      }

      if (nichtbestatter || registerGewerbe) {
        privacy.textContent = "Ich bestätige hiermit, dass ich Unternehmer, Gewerbetreibender, Freiberufler oder eine öffentliche Institution bin und kein Verbraucher im Sinne des § 13 BGB.";
      }
    }
  }, 300); 
  setTimeout(() => {
      clearInterval(interval);
  },8000)
}


// Conditional-Logic für das ein und ausblenden des VAT-Feldes entspreched der Länderauswahl

const initVatToggle = () => {
  const form = document.getElementById("bss-b2b-registration-form");
  if (!form) return false;

  const vatField = form.querySelector("#vat-validation");
  const vatLabel = form.querySelector('label[for="vat-validation"]');
  const vatContainer = vatField ? vatField.closest(".bss-b2b-rf-field") : null;

  const countryName = document.getElementById("country-name");
  const countryField = document.getElementById("country-field");
  const countryList = document.getElementById("country-list");

  if (!vatField || !vatLabel || !vatContainer || !countryName || !countryList) return false;

  if (!vatField.dataset.origName && vatField.name) vatField.dataset.origName = vatField.name;

  const euCountries = [
    "BE","BG","DK","EE","FI","FR","GR","IE","IT","HR","LV","LT",
    "LU","MT","NL","AT","PL","PT","RO","SE","SK","SI","ES","CZ",
    "HU","CY"
  ];

  const getCountryCode = () => {
    if (countryField && countryField.value) return countryField.value.toUpperCase();
    const name = (countryName.value || "").trim().toLowerCase();
    if (!name) return "";
    const li = Array.from(countryList.querySelectorAll("li")).find(
      el => el.textContent.trim().toLowerCase() === name
    );
    if (li) return (li.getAttribute("value") || "").toUpperCase();
    if (name.length === 2) return name.toUpperCase();
    return "";
  };

  const showVat = () => {
    vatContainer.removeAttribute("bss-b2b-rf-conditional-logic-hide");
    vatField.disabled = false;
    if (!vatField.name && vatField.dataset.origName) vatField.name = vatField.dataset.origName;
    vatLabel.style.display = "";
    vatField.style.display = "";
    if (window.BSS_B2B?.rf?.vatResult) window.BSS_B2B.rf.vatResult["vat-validation"] = undefined;
    document.dispatchEvent(new Event("BSS_conditional_logic_change"));
    document.dispatchEvent(new Event("BSS_condition_field_change"));
  };

  const hideVat = () => {
    vatContainer.setAttribute("bss-b2b-rf-conditional-logic-hide", "");
    const msg = vatContainer.querySelector(".bss-message");
    if (msg) msg.innerHTML = "";
    vatField.value = "";
    vatField.disabled = true;
    if (vatField.name) vatField.removeAttribute("name");
    vatLabel.style.display = "none";
    vatField.style.display = "none";
    if (window.BSS_B2B?.rf) {
      if (!window.BSS_B2B.rf.vatResult) window.BSS_B2B.rf.vatResult = {};
      window.BSS_B2B.rf.vatResult["vat-validation"] = true;
    }
    document.dispatchEvent(new Event("BSS_conditional_logic_change"));
    document.dispatchEvent(new Event("BSS_condition_field_change"));
  };

  const toggleVatVisibility = () => {
    euCountries.includes(getCountryCode()) ? showVat() : hideVat();
  };

  toggleVatVisibility();
  countryName.addEventListener("input", toggleVatVisibility);
  countryName.addEventListener("change", toggleVatVisibility);
  if (countryField) countryField.addEventListener("change", toggleVatVisibility);
  countryList.addEventListener("click", () => { setTimeout(toggleVatVisibility, 0); });

  return true;
};

const iv = setInterval(() => {
  if (initVatToggle()) clearInterval(iv);
}, 300);

setTimeout(() => {
  clearInterval(iv);
}, 10000);
